import MainMenu from './MainMenu'
import AutoCompleteCompany from './AutoCompleteCompany'
import AutoCompleteCostCenterSingle from './AutoCompleteCostCenterSingle'
import MenuItemPeriod from './MenuItemPeriod.json'
import AdjustValueDialog from './AdjustValueDialog'
import AutoComplete from './AutoComplete'
import WebCallCompanyDialog from './WebCallCompanyDialog'
import GlobalDrawer from './GlobalDrawer'
import ExpiresSessionDialog from './ExpiresSessionDialog'
import SessionExpiresWarning from './SessionExpiresWarning'
import LoginAttemptsWarning from './LoginAttemptsWarning'
import CompanyMenuActions from './CompanyMenuActions'
import XLSXInput from './XLSXInput'
import OnboardingForm from './OnboardingForm'
import AutoCompleteAsync from './AutoCompleteAsync'
import BrowserCompatibilityDialog from './BrowserCompatibilityDialog'
import ConnectionMonitoring from './ConnectionMonitoring'

// Home
import PerformanceChart from './PerformanceChart'
import Performance from './Performance'
import RideCategoriesStatus from './RideCategoriesStatus'
import RideValuesStatus from './RideValuesStatus'
import RegistersWithoutCellPhone from './RegistersWithoutCellPhone'
import LatestRidesSidebar from './LatestRidesSidebar'

// Employees
import EmployeeForm from './EmployeeForm'
import EmployeesBulkImportDialog from './EmployeesBulkImportDialog'
import CostCentersBulkImportDialog from './CostCentersBulkImportDialog'
import NewEmployeeDialog from './NewEmployeeDialog'
import CostCenterForm from './CostCenterForm'
import NewCostCenterDialog from './NewCostCenterDialog'
import ApplyToAllDialog from './ApplyToAllDialog'
import FlexibleBenefitConfirmDialog from './FlexibleBenefitConfirmDialog'

// Projects
import ProjectForm from './ProjectForm'
import NewProjectDialog from './NewProjectDialog'

// Company
import AllowEmployeeAccessCard from './AllowEmployeeAccessCard'
import CompanyStatusCard from './CompanyStatusCard'
import RideJustificationCard from './RideJustificationCard'
import CreditPolicyCard from './CreditPolicyCard'
import TimetablePolicyCard from './TimetablePolicyCard'
import DailyLimitCard from './DailyLimitCard.json'
import SendingRideReceipts from './SendingRideReceipts'
import CompanyFinancialConfig from './CompanyFinancialConfig'
import Incentives from './Incentives'
import SmsNotification from './SmsNotification'
import PartnerApi from './PartnerApi'
import ProjectsMandatorySwitch from './ProjectsMandatorySwitch'

// Reports
import ReportChart from './ReportChart.json'
import ReportRides from './ReportRides.json'
import ReportDrawer from './ReportDrawer.json'

// Financial
import PaymentMethod from './PaymentMethod.json'
import PaymentMethodForm from './PaymentMethodForm.json'
import CreditCard from './CreditCard'
import FinancialDropdownActions from './FinancialDropdownActions'
import FinancialDropdownActions2 from './FinancialDropdownActions2'
import FinancialInvoicesHistory from './FinancialInvoicesHistory'
import FinancialDialog from './FinancialDialog'

// Access profiles
import AccessProfilesDrawer from './AccessProfilesDrawer'
import BulkImportDialog from './BulkImportDialog'
import PasswordTips from './PasswordTips'
import AllowWebCallSwitch from './AllowWebCallSwitch'
import AllowApiToken from './AllowApiToken'

export default {
  MainMenu,
  EmployeeForm,
  EmployeesBulkImportDialog,
  NewEmployeeDialog,
  CostCentersBulkImportDialog,
  CostCenterForm,
  NewCostCenterDialog,
  ApplyToAllDialog,
  FlexibleBenefitConfirmDialog,
  AutoCompleteCompany,
  ProjectForm,
  NewProjectDialog,
  AutoCompleteCostCenterSingle,
  AllowEmployeeAccessCard,
  CompanyStatusCard,
  RideJustificationCard,
  CreditPolicyCard,
  TimetablePolicyCard,
  DailyLimitCard,
  SendingRideReceipts,
  CompanyFinancialConfig,
  Incentives,
  MenuItemPeriod,
  AdjustValueDialog,
  AutoComplete,
  WebCallCompanyDialog,
  GlobalDrawer,
  ExpiresSessionDialog,
  SessionExpiresWarning,
  LoginAttemptsWarning,
  CompanyMenuActions,
  XLSXInput,
  OnboardingForm,
  AutoCompleteAsync,
  BrowserCompatibilityDialog,
  ConnectionMonitoring,
  PerformanceChart,
  Performance,
  RideCategoriesStatus,
  RideValuesStatus,
  RegistersWithoutCellPhone,
  LatestRidesSidebar,
  ReportChart,
  ReportRides,
  ReportDrawer,
  PaymentMethod,
  PaymentMethodForm,
  CreditCard,
  FinancialDropdownActions,
  FinancialDropdownActions2,
  FinancialInvoicesHistory,
  FinancialDialog,
  AccessProfilesDrawer,
  BulkImportDialog,
  PasswordTips,
  SmsNotification,
  PartnerApi,
  AllowWebCallSwitch,
  AllowApiToken,
  ProjectsMandatorySwitch
}
